// Los datos fluyen desde aqui nada más
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
//Crear el context
export const CategoriesContext = createContext();
//Provider es donde se encuentan las funciones y state

const CategoriesProvider = (props) => {

    const [categories, saveCategories] = useState([]);

    useEffect(() => {
        const getCategories = async () => {
            const url = `https://www.thecocktaildb.com/api/json/v1/1/list.php?c=list`;
            const result = await axios.get(url);
            // console.log(result.data.drinks);
            saveCategories(result.data.drinks);
        }
        getCategories();
    }, []);

    // lo que este en return es lo que va a estar disponible realmente
    return (
        <CategoriesContext.Provider
            value={{
                categories
            }}
        >
            {props.children}
        </CategoriesContext.Provider>
    )
}

export default CategoriesProvider;